// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"c13e2b30","232":"a161ff31","237":"9d74de55","526":"b7f1fdc5","872":"98ec6393"}[chunkId] + ".chunk.js";
};